import React, { useContext } from 'react';
import { Table } from 'react-bootstrap';
import Context from '../../context/MyContext';
import './style.css';

function TableApp() {
  const { filteredData } = useContext(Context);

  return (
    <Table striped bordered hover responsive size="sm" variant="dark">
      <thead>
        <tr>
          <th>Name</th>
          <th>Rotation Period</th>
          <th>Orbital Period</th>
          <th>Diameter</th>
          <th>Climate</th>
          <th>Gravity</th>
          <th>Terrain</th>
          <th>Surface Water</th>
          <th>Population</th>
          <th>Films</th>
          <th>Created</th>
          <th>Edited</th>
          <th>Url</th>
        </tr>
      </thead>
      <tbody>
        {/* Optional Chaining - https://www.freecodecamp.org/news/how-the-question-mark-works-in-javascript/ */}
        {filteredData.map((planet, index) => (
          <tr key={ index }>
            <td data-testid="planet-name">{ planet.name }</td>
            <td>{ planet.rotation_period }</td>
            <td>{ planet.orbital_period }</td>
            <td>{ planet.diameter }</td>
            <td>{ planet.climate }</td>
            <td>{ planet.gravity }</td>
            <td>{ planet.terrain }</td>
            <td>{ planet.surface_water }</td>
            <td>{ planet.population }</td>
            <td>{ planet.films }</td>
            <td>{ planet.created }</td>
            <td>{ planet.edited }</td>
            <td>{ planet.url }</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}

export default TableApp;
